import * as React from 'react';
import { isNil } from 'lodash';

import EntityAvatar from 'components/entity/entity-avatar/EntityAvatar';
import InfluencerVerificationLabel from 'components/influencer-verification-label/InfluencerVerificationLabel';

import InfluencerCreatorNetworkListItemMetrics
  from 'modules/influencers/components/creator-modal/metrics/InfluencerCreatorNetworkListItemMetrics';

import type { AgencyProfile } from 'modules/influencers/types/AgencyProfile.type';

import './agency-creators-item.scss';

type Props = {
  creatorProfile: AgencyProfile
};

const AgencyCreatorItem = ({ creatorProfile }: Props): JSX.Element => {
  const instagramChannel = creatorProfile.channels?.instagram;
  const tiktokChannel = creatorProfile.channels?.tiktok;

  const profileLink = `/content-creator/profiles/${creatorProfile.id}`;

  return (
    <div
      className="agency-creators-item__content-wrapper"
    >
      <div className="agency-creators-item__creator">
        <EntityAvatar
          bordered
          openInNewTab
          entity={{
            image: creatorProfile.profileImage
          }}
          link={profileLink}
          customSize={{ width: 24, height: 24 }}
          onClick={(event) => { event.stopPropagation(); }}
        />
        <div className="agency-creators-item__creator-name">
          <a
            href={profileLink}
            className="agency-creators-item__creator-name-link"
            rel="noopener noreferrer"
            target="_blank"
            onClick={(event) => { event.stopPropagation(); }}
          >
            {creatorProfile.name}
          </a>
        </div>
        <InfluencerVerificationLabel
          type="verified"
        />
      </div>
      <div className="agency-creators-item__metrics">
        {
          !isNil(instagramChannel) && !isNil(instagramChannel.username) && (
            <InfluencerCreatorNetworkListItemMetrics
              channel="instagram"
              engagementRate={instagramChannel.metrics?.engagement}
              followers={instagramChannel.metrics?.followers}
              channelLink={instagramChannel.url}
            />
          )
        }
      </div>
      <div className="agency-creators-item__metrics">
        {
          !isNil(tiktokChannel) && !isNil(tiktokChannel.username) && (
            <InfluencerCreatorNetworkListItemMetrics
              channel="tiktok"
              engagementRate={tiktokChannel.metrics?.engagement}
              followers={tiktokChannel.metrics?.followers}
              channelLink={tiktokChannel.url}
            />
          )
        }
      </div>
    </div>
  );
};

export default AgencyCreatorItem;
